<!--
 * @Auther: 罗耀祖
 * @Date: 2021-09-17 11:46:46
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-07-27 17:20:15
 * @name: 工作流设计
 * @Description: 工作流设计
 * @FilePath: \preSaleNafterSaleBackstage\src\views\approvalManage\flowManageDesign.vue
 * @Author: desktop
-->
<template>
  <flow-panel ref="flowPanel" class="flowPanel" :flow="flow"></flow-panel>
</template>
<script>
import FlowPanel from "@/components/ef/panel.vue";
import flow from "@/object/flow/flow.class.js";
import store from "@/store";
export default {
  name: "flowManageDesign",
  components: {
    FlowPanel,
  },
  data() {
    return {
      flow: new flow(),
    };
  },
  created() {
    this.$nextTick(() => {
      this.$refs.flowPanel.start(this.$route.query?.flow_id ?? "");
    });
  },
  beforeRouteEnter(to, from, next) {
    new flow().workflowVersiongetList().then((res) => {
      store.dispatch("flowVersion/versionsChange", res.data);
      store.dispatch("flowVersion/nowVersionChange", res.data[0]);
      next();
    });
  },
};
</script>
<style lang="scss" scoped>
.flowPanel {
  background: white;
}
</style>
